import React from 'react';
import { OrderPaymentAction } from '../../../components/Order/List/OrderPaymentActions';
export default (function (_a) {
    var config = _a.config, record = _a.record, isCost = _a.isCost, disabled = _a.disabled, onChange = _a.onChange, label = _a.label;
    if (record.quote && record.quote._id && record.quote.order) {
        return (React.createElement(OrderPaymentAction, { isInvoice: true, disabled: disabled, onChange: onChange, isCost: isCost, order: record.quote.order, config: config, label: label }));
    }
    return (React.createElement(OrderPaymentAction, { isInvoice: true, onChange: onChange, disabled: disabled, isCost: isCost, invoice: record, config: config, label: label }));
});
